import QuickReplies from './QuickReplies';

export default QuickReplies;
